"use client";

import { useTranslations, useLocale } from "@/lib/compat/i18n";
import clsx from "clsx";

const TONE_BY_STATE: Record<string, string> = {
  DRAFT:                    "border-orbitra-muted   text-orbitra-muted",
  TRANSMITTED:              "border-state-traced    text-state-traced",
  ACCEPTED:                 "border-state-traced    text-state-traced",
  EXTERNALLY_VALIDATED:     "border-state-traced    text-state-traced",
  SINGLE_WINDOW_SUBMITTED:  "border-state-financed  text-state-financed",
  MATCHED:                  "border-policy-pass     text-policy-pass",
  DISPUTED:                 "border-policy-fail     text-policy-fail",
  REJECTED:                 "border-policy-fail     text-policy-fail",

  PASS:                     "border-policy-pass          text-policy-pass",
  FAIL:                     "border-policy-fail          text-policy-fail",
  INDETERMINATE:            "border-policy-indeterminate text-policy-indeterminate",
  OVERRIDDEN:               "border-policy-overridden    text-policy-overridden",
};

/**
 * CdmState renders the canonical English token (always preserved, always LTR
 * even under RTL layout) and, when locale is non-English, a localised line
 * underneath. Decision 14 in the plan: state names are bilingual when the
 * audience-facing locale is non-English.
 */
export function CdmState({ token, className }: { token: string; className?: string }) {
  const t = useTranslations("cdmStates");
  const locale = useLocale();
  const localised = locale === "en" ? null : t(token, { fallback: "" });
  return (
    <span className={clsx(
      "inline-flex flex-col items-start rounded-md border px-2 py-1",
      TONE_BY_STATE[token] ?? "border-orbitra-muted text-orbitra-muted",
      className,
    )}>
      <span className="cdm-state-token text-[10px] font-semibold leading-tight">{token}</span>
      {localised && <span className="text-[9px] opacity-70 leading-tight">{localised}</span>}
    </span>
  );
}
